import { actions } from './actions'

const initialState = {
  categorias: {
    data: [],
    loading: false,
    error: '',
  },
  subcategorias: {
    data: [],
    loading: false,
    error: '',
  },
  categoriaPersonalizados: {
    data: [],
    loading: false,
    error: '',
  },
  categoria: {
    data: null,
    loading: false,
    error: '',
  },
}

function removeCategorias(list, idsToRemove) {  
  const ids = Array.isArray(idsToRemove) ? idsToRemove : [idsToRemove];

  return list
    .filter(item => !ids.includes(item.id))
    .map(item => ({
      ...item,
      children: item.children ? removeCategorias(item.children, ids) : [],
    }));
}

export default function categoriaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CATEGORIAS_LOAD_REQUESTED:
      return {
        ...state,
        categorias: { ...state.categorias, loading: true },
      }
    case actions.CATEGORIAS_LOAD_FILTERED_REQUESTED:
      return {
        ...state,
        categorias: { ...state.categorias, loading: true },
      }
    case actions.CATEGORIAS_CHILD_LOAD_REQUESTED:
      return {
        ...state,
        categorias: { ...state.categorias, loading: true },
      }
    case actions.CATEGORIAS_LOAD_SUCCEEDED:
      return {
        ...state,
        categorias: { ...state.categorias, data: action.payload, loading: false },
      }
    case actions.CATEGORIAS_LOAD_FILED:
      return {
        ...state,
        categorias: { ...state.categorias, loading: false, error: action.error },
      }
    case actions.SUBCATEGORIAS_LOAD_REQUESTED:
      return {
        ...state,
        subcategorias: { ...state.subcategorias, loading: true },
      }
    case actions.SUBCATEGORIAS_LOAD_SUCCEEDED:
      return {
        ...state,
        subcategorias: { ...state.subcategorias, data: action.payload, loading: false },
      }
    case actions.SUBCATEGORIAS_LOAD_FILED:
      return {
        ...state,
        subcategorias: { ...state.subcategorias, loading: false, error: action.error },
      }
    case actions.CATEGORIA_PERSONALIZADOS_LOAD_REQUESTED:
      return {
        ...state,
        categoriaPersonalizados: { ...state.categoriaPersonalizados, loading: true },
      }
    case actions.CATEGORIA_PERSONALIZADOS_LOAD_SUCCEEDED:
      return {
        ...state,
        categoriaPersonalizados: {
          ...state.categoriaPersonalizados,
          data: action.payload,
          loading: false,
        },
      }
    case actions.CATEGORIA_PERSONALIZADOS_LOAD_FILED:
      return {
        ...state,
        categoriaPersonalizados: {
          ...state.categoriaPersonalizados,
          loading: false,
          error: action.error,
        },
      }
    case actions.CATEGORIA_BYID_LOAD_REQUESTED:
      return {
        ...state,
        categoria: { ...state.categoria, loading: true, error: '' },
      }
    case actions.CATEGORIA_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        categoria: { ...state.categoria, data: action.payload, loading: false, error: '' },
      }
    case actions.CATEGORIA_BYID_LOAD_FILED:
      return {
        ...state,
        categoria: { ...state.categoria, data: null, loading: false, error: action.error },
      }
    case actions.CATEGORIA_BYID_LOAD_INSERT_REQUESTED:
      return {
        ...state,
        categoria: { ...state.categoria, data: null, loading: false, error: '' },
      }
    case actions.CATEGORIA_UPDATE_REQUESTED:
      return {
        ...state,
        categoria: { ...state.categoria, loading: true, error: '' },
      }
    case actions.CATEGORIA_UPDATE_SUCCEEDED:
      return {
        ...state,
        categoria: { ...state.categoria, data: action.payload, loading: false, error: '' },
      }
    case actions.CATEGORIA_UPDATE_FILED:
      return {
        ...state,
        categoria: { ...state.categoria, loading: false, error: action.error },
      }
    case actions.CATEGORIA_INSERT_REQUESTED:
      return {
        ...state,
        categoria: { ...state.categoria, loading: true, error: '' },
      }
    case actions.CATEGORIA_INSERT_SUCCEEDED:
      return {
        ...state,
        categoria: { ...state.categoria, data: action.payload, loading: false, error: '' },
      }
    case actions.CATEGORIA_INSERT_FILED:
      return {
        ...state,
        categoria: { ...state.categoria, loading: false, error: action.error },
      }

    case actions.CATEGORIA_DELETE_REQUESTED:
      return {
        ...state,
        categorias: { ...state.categorias, loading: true, error: '' },
      }
    case actions.CATEGORIA_DELETE_SUCCEEDED:
      return {
        ...state,
        categorias: {
          ...state.categorias,
          data: removeCategorias(state.categorias.data, action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.CATEGORIA_DELETE_FILED:
      return {
        ...state,
        categorias: { ...state.categorias, loading: false, error: action.error },
      }
    case actions.CATEGORIAS_DELETE_REQUESTED:
      return {
        ...state,
        categorias: { ...state.categorias, loading: true, error: '' },
      }
    case actions.CATEGORIAS_DELETE_SUCCEEDED:
      return {
        ...state,
        categorias: {
          ...state.categorias,
          data: removeCategorias(state.categorias.data, action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.CATEGORIAS_DELETE_FILED:
      return {
        ...state,
        categorias: { ...state.categorias, loading: false, error: action.error },
      }
    case actions.CATEGORIA_PERSONALIZADOS_UPDATE_REQUESTED:
      return {
        ...state,
        categoriaPersonalizados: { ...state.categoriaPersonalizados, loading: true, error: '' },
      }
    case actions.CATEGORIA_PERSONALIZADOS_UPDATE_SUCCEEDED:
      return {
        ...state,
        categoriaPersonalizados: {
          ...state.categoriaPersonalizados,
          data: state.categoriaPersonalizados.data.map(catPer =>
            catPer.id === action.payload.id ? action.payload : catPer,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.CATEGORIA_PERSONALIZADOS_UPDATE_FILED:
      return {
        ...state,
        categoriaPersonalizados: {
          ...state.categoriaPersonalizados,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
